import React from 'react'
import { useSelector } from 'react-redux'
import { Card, CardContent, Grid, Typography } from '../../../../components/mui/Core/index'
import { getNumberValueFormat } from '../../../../utils/string-utils'
import Constants from '../../../../constants/en.json'
import { sessionStorageKeyConstants } from '../../../../constants/session-storage-key-constants'

export function ItemDetailsCard() {
  const authenticatedUser = useSelector((state) => state.login.authenticatedUser)
  const selectedClient = JSON.parse(
    sessionStorage.getItem(sessionStorageKeyConstants.SELECTED_CLIENT),
  )
  const dmsUser = selectedClient ? selectedClient?.dmsFlag : authenticatedUser?.dms
  const selectedItem = useSelector((state) => state.inventory.selectedInventoryItem)
  const cardStyle = { borderRadius: '12px' }
  const cardContentStyle = { padding: '20px !important' }
  const priceStyle = { ml: 15 }
  const uomStyle = { pl: 6 }

  return (
    <Card variant='outlined' sx={cardStyle}>
      <CardContent sx={cardContentStyle}>
        {dmsUser === 'Y' ? (
          <Grid>
            <Grid container spacing={2}>
              <Grid size={{ xs: 6 }}>
                <Typography variant='h6'>{Constants.inventory.DESCRIPTION}</Typography>
              </Grid>
              <Grid size={{ xs: 1 }}>
                <Typography variant='h6' align='right'>
                  {Constants.inventory.LIVE_QTY}
                </Typography>
              </Grid>
              <Grid size={{ xs: 0.8 }} sx={uomStyle}>
                <Typography variant='h6'>{Constants.inventory.UOM}</Typography>
              </Grid>
              <Grid size={{ xs: 0.9 }}>
                <Typography variant='h6' align='right'>
                  {Constants.inventory.TOTAL_QTY}
                </Typography>
              </Grid>
              <Grid size={{ xs: 3 }}>
                <Typography variant='h6' align='right'>
                  {Constants.inventory.WAC_UNIT_PRICE}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid size={{ xs: 6 }}>
                <Typography variant='body1'>{selectedItem?.itemDescription}</Typography>
              </Grid>
              <Grid size={{ xs: 1 }}>
                <Typography variant='body1' align='right'>
                  {getNumberValueFormat(selectedItem?.liveQuantity)}
                </Typography>
              </Grid>
              <Grid size={{ xs: 0.8 }} sx={uomStyle}>
                <Typography variant='body1'>{selectedItem?.uom}</Typography>
              </Grid>
              <Grid size={{ xs: 0.9 }}>
                <Typography variant='body1' align='right'>
                  {getNumberValueFormat(selectedItem?.quantity)}
                </Typography>
              </Grid>
              <Grid size={{ xs: 3 }}>
                <Typography variant='body1' align='right' sx={priceStyle}>
                  ${selectedItem?.wacListPrice}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Grid>
            <Grid container spacing={2}>
              <Grid size={{ xs: 9 }}>
                <Typography variant='h6'>{Constants.inventory.DESCRIPTION}</Typography>
              </Grid>
              <Grid size={{ xs: 1 }}>
                <Typography variant='h6' align='right'>
                  {Constants.inventory.LIVE_QTY}
                </Typography>
              </Grid>
              <Grid size={{ xs: 1 }}>
                <Typography variant='h6' sx={uomStyle}>
                  {Constants.inventory.UOM}
                </Typography>
              </Grid>
              <Grid size={{ xs: 0.9 }}>
                <Typography variant='h6' align='right'>
                  {Constants.inventory.TOTAL_QTY}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid size={{ xs: 9 }}>
                <Typography variant='body1'>{selectedItem?.itemDescription}</Typography>
              </Grid>
              <Grid size={{ xs: 1 }}>
                <Typography variant='body1' align='right'>
                  {getNumberValueFormat(selectedItem?.liveQuantity)}
                </Typography>
              </Grid>
              <Grid size={{ xs: 1 }}>
                <Typography variant='body1' sx={uomStyle}>
                  {selectedItem?.uom}
                </Typography>
              </Grid>
              <Grid size={{ xs: 0.9 }}>
                <Typography variant='body1' align='right'>
                  {getNumberValueFormat(selectedItem?.quantity)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        )}
      </CardContent>
    </Card>
  )
}

export default ItemDetailsCard
